import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          Coded with ReactJS <i className="f-text f-heart-symbol">&#10084;</i>
          by
          <span className="f-text dev-name nowrap"> Shalu Ambasta</span>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
